import type { AxiosInstance } from 'axios';
import type {
  Asset,
  AssetListResponse,
  EntityId,
} from '@/types';

export const getAssets = async (
  api: AxiosInstance,
  chat_id: EntityId,
): Promise<AssetListResponse> => {
  const resp = await api.get<AssetListResponse>(`/chat/${chat_id}/asset`);
  return resp.data;
};

export const getAsset = async (
  api: AxiosInstance,
  chat_id: EntityId,
  asset_id: EntityId,
): Promise<Asset> => {
  const resp = await api.get<Asset>(`/chat/${chat_id}/asset/${asset_id}`);
  return resp.data;
};

export const insertAsset = async (
  api: AxiosInstance,
  chat_id: EntityId,
  file_name: string,
  content_type: string,
  data: Blob | ArrayBuffer | FormData,
): Promise<Asset> => {
  const resp = await api.post<Asset>(`/chat/${chat_id}/asset`, data, {
    params: { file_name },
    headers: {
      'Content-Type': content_type,
    },
  });
  return resp.data;
};

export const updateAsset = async (
  api: AxiosInstance,
  chat_id: EntityId,
  asset_id: EntityId,
  content_type: string,
  data: Blob | ArrayBuffer | FormData,
): Promise<Asset> => {
  const resp = await api.put<Asset>(`/chat/${chat_id}/asset/${asset_id}`, data, {
    headers: {
      'Content-Type': content_type,
    },
  });
  return resp.data;
};

export const deleteAsset = async (
  api: AxiosInstance,
  chat_id: EntityId,
  asset_id: EntityId,
): Promise<void> => {
  const resp = await api.delete(`/chat/${chat_id}/asset/${asset_id}`);
  return resp.data;
};

